;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["initial-merchant", "initial-merchants", "initial-services", "initial-perms", "permissions", "fetchServicesUrl", "merchantsUrl", "merchantslist", "initial-agency"],
  data: function data() {
    return {
      merchantId: this.initialMerchant,
      merchantIds: this.initialMerchants,
      serviceIds: this.initialServices,
      availablePermissions: this.permissions.admin.concat(this.permissions.basic),
      selectedPerms: this.initialPerms,
      merchants: [],
      ml: this.merchantslist,
      agencyId: this.initialAgency,
      show_merchants_input: true,
      show_agency_input: true,
      show_gateways_input: true
    };
  },
  computed: {
    agency: function agency() {
      return this.agencyId;
    }
  },
  methods: {
    on_add_merchant: function on_add_merchant(value) {
      this.merchants.push(value[0]);
      var selectedMerchantIds = encodeURIComponent((0, _stringify2.default)(value));
      $.getJSON(this.fetchServicesUrl.replace("merchant_ids", selectedMerchantIds), function (data) {
        data.map(function (v) {
          return $("#services").multiSelect("addOption", {
            value: v.id,
            text: v.name
          });
        });
      });
    },
    on_remove_merchant: function on_remove_merchant(value) {
      var x = value[0].toString();
      var index = this.merchantIds.indexOf(parseInt(x));
      if (index > -1) {
        this.merchantIds.splice(index, 1);
      }
      var selectedMerchantIds = encodeURIComponent((0, _stringify2.default)(value));
      $.getJSON(this.fetchServicesUrl.replace("merchant_ids", selectedMerchantIds), function (data) {});
    },
    deselectperms: function deselectperms(value) {
      var index = this.selectedPerms.indexOf(parseInt(value));
      if (index > -1) {
        this.selectedPerms.splice(index, 1);
      }
    },

    onMerchantChange: function onMerchantChange(evt) {
      this.availableServices = [];
      this.selectedPerms = [];
      this.loadServicesForMerchants();
      if (this.merchantId !== "none") {
        this.show_agency_input = false;
        this.show_gateways_input = false;
      }
    },

    onMerchantsChange: function onMerchantsChange(evt) {
      this.loadServicesForMerchants();
    },

    onAgencyChange: function onAgencyChange() {
      this.show_gateways_input = false;
      this.show_merchants_input = false;
    },

    loadServicesForMerchants: function loadServicesForMerchants() {
      var selectedMerchantIds = null;
      this.serviceIds = this.initialServices;

      if (this.merchantId == "none") {
        selectedMerchantIds = this.merchantIds;
        this.ml.map(function (v) {
          return $("#merchantlist").multiSelect("addOption", {
            value: v.id,
            text: v.name
          });
        });

        $("#services option:selected").prop("selected", false);
        $("#services option").remove();
        $("#services").multiSelect("refresh");

        this.ml.map(function (v) {
          return $("#merchantlist").multiSelect("addOption", {
            value: v.id,
            text: v.name
          });
        });

        $("#services option:selected").prop("selected", false);
        $("#services option").remove();
        $("#services").multiSelect("refresh");

        this.availablePermissions = this.permissions.admin.concat(this.permissions.basic);

        $("#permissions option:selected").prop("selected", false);
        $("#permissions option").remove();
        $("#permissions").multiSelect("refresh");
        this.availablePermissions.map(function (v) {
          return $("#permissions").multiSelect("addOption", {
            value: v.value,
            text: v.label
          });
        });
      } else if (!!this.merchantId) {
        $("#merchantlist option:selected").prop("selected", false);
        $("#merchantlist option").remove();
        $("#merchantlist").multiSelect("refresh");

        selectedMerchantIds = [this.merchantId];
        this.availablePermissions = this.permissions.basic;
        $("#permissions option:selected").prop("selected", false);
        $("#permissions option").remove();
        $("#permissions").multiSelect("refresh");
        this.availablePermissions.map(function (v) {
          return $("#permissions").multiSelect("addOption", {
            value: v.value,
            text: v.label
          });
        });
      }

      if (selectedMerchantIds && selectedMerchantIds.length > 0) {
        selectedMerchantIds = encodeURIComponent((0, _stringify2.default)(selectedMerchantIds));

        $.getJSON(this.fetchServicesUrl.replace("merchant_ids", selectedMerchantIds), function (data) {
          var _this = this;

          this.availableServices = data;

          $("#services option:selected").prop("selected", false);
          $("#services option").remove();
          $("#services").multiSelect("refresh");

          this.availableServices.map(function (v) {
            return $("#services").multiSelect("addOption", {
              value: v.id,
              text: v.name
            });
          });
          data.forEach(function (v) {
            if (_this.initialServices.includes(v.id)) {
              $("#services option[value='" + v.id + "']").attr("selected", true);
              $("#services option[value='" + v.name + "']").attr("selected", true);
              $("#services").multiSelect("refresh");
            }
          });
        }.bind(this));
      } else {}
    },
    loadMerchants: function loadMerchants() {
      $.getJSON(this.merchantsUrl, function (data) {
        this.merchants = [{
          name: "None",
          id: "none"
        }].concat(data);
      });
    }
  },

  created: function created() {
    this.loadServicesForMerchants();
    this.loadMerchants();
  },

  mounted: function mounted() {
    var vm = this;

    $("#permissions").multiSelect({
      selectableHeader: "<input type='text' class='form-control search-input' autocomplete='off' placeholder='Available'>",
      selectionHeader: "<input type='text' class='form-control search-input' autocomplete='off' placeholder='Selected'>",
      afterInit: function afterInit(ms) {
        var that = this,
            $selectableSearch = that.$selectableUl.prev(),
            $selectionSearch = that.$selectionUl.prev(),
            selectableSearchString = "#" + that.$container.attr("id") + " .ms-elem-selectable:not(.ms-selected)",
            selectionSearchString = "#" + that.$container.attr("id") + " .ms-elem-selection.ms-selected";

        that.qs1 = $selectableSearch.quicksearch(selectableSearchString).on("keydown", function (e) {
          if (e.which === 40) {
            that.$selectableUl.focus();
            return false;
          }
        });

        that.qs2 = $selectionSearch.quicksearch(selectionSearchString).on("keydown", function (e) {
          if (e.which == 40) {
            that.$selectionUl.focus();
            return false;
          }
        });
      },
      afterSelect: function afterSelect(value) {
        this.qs1.cache();
        this.qs2.cache();
      },
      afterDeselect: function afterDeselect(value) {
        this.qs1.cache();
        this.qs2.cache();
        vm.deselectperms(value);
      }
    });

    $("#merchantlist").multiSelect({
      selectableHeader: "<input type='text' class='form-control search-input' autocomplete='off' placeholder='Available'>",
      selectionHeader: "<input type='text' class='form-control search-input' autocomplete='off' placeholder='Selected'>",
      afterInit: function afterInit(ms) {
        var that = this,
            $selectableSearch = that.$selectableUl.prev(),
            $selectionSearch = that.$selectionUl.prev(),
            selectableSearchString = "#" + that.$container.attr("id") + " .ms-elem-selectable:not(.ms-selected)",
            selectionSearchString = "#" + that.$container.attr("id") + " .ms-elem-selection.ms-selected";

        that.qs1 = $selectableSearch.quicksearch(selectableSearchString).on("keydown", function (e) {
          if (e.which === 40) {
            that.$selectableUl.focus();
            return false;
          }
        });

        that.qs2 = $selectionSearch.quicksearch(selectionSearchString).on("keydown", function (e) {
          if (e.which == 40) {
            that.$selectionUl.focus();
            return false;
          }
        });
      },
      afterSelect: function afterSelect(value) {
        this.qs1.cache();
        this.qs2.cache();
        vm.on_add_merchant(value);
      },
      afterDeselect: function afterDeselect(value) {
        this.qs1.cache();
        this.qs2.cache();
        vm.on_remove_merchant(value);
      }
    });
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e6690ed2", __vue__options__)
  } else {
    hotAPI.reload("data-v-e6690ed2", __vue__options__)
  }
})()}